import { render, staticRenderFns } from "./StatusLegend.vue?vue&type=template&id=d4ff8f4a&scoped=true"
import script from "./StatusLegend.vue?vue&type=script&lang=js"
export * from "./StatusLegend.vue?vue&type=script&lang=js"
import style0 from "./StatusLegend.vue?vue&type=style&index=0&id=d4ff8f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ff8f4a",
  null
  
)

export default component.exports